import { IS_LOADING } from "lib/graphql/return-is-loading-on-each-request"
import { withInitialValue } from "lib/graphql/with-initial-value"
import { getMacroCount } from "authoring/routes/macro/controller/get-macro-count"
import { AuthoringHomeStatTile } from "../authoring-home-stat-tile"

export function AuthoringHomeMacrosTile() {
    const count = getMacroCount.useResults({}, withInitialValue(IS_LOADING))

    return (
        <AuthoringHomeStatTile
            title="Macro"
            pluralTitle="Macros"
            count={count === IS_LOADING ? IS_LOADING : count ?? 0}
            icon="mdi:code-braces"
            palette="warning"
            to="/authoring/macros"
        />
    )
}
